import React from "react";

const HorizontalRule = ({ blok }) => {
   return <hr />;
};

export default HorizontalRule;
